import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import {
    IconCategoryCard,
    IconCategoryWrapper,
} from '../../components/IconCategoryBrowse';
import { CATEGORIES } from '../../components/IconCategoryBrowse/__fixtures__/IconCategories';
import { STATSIG_HOME_CLICK_TRENDING_CATEGORY } from '../../constants/analytics';
import './IconCategoryBrowse.scss';
export const IconCategoryBrowse = () => {
    return (
        <section
            className="iconCategoryBrowse"
            data-testid="icon-category-browse"
        >
            <IconCategoryWrapper cards={CATEGORIES}>
                {(category) => {
                    return (
                        <a
                            key={category?.key}
                            href={`/d/local/${category?.key}--events/?page=1`}
                            data-testid="category-card"
                            data-heap-id="homepage-category-tiles"
                            onClick={() => {
                                logEvent(STATSIG_HOME_CLICK_TRENDING_CATEGORY);
                            }}
                        >
                            <IconCategoryCard
                                title={category?.name || ''}
                                icon={category?.icon}
                            />
                        </a>
                    );
                }}
            </IconCategoryWrapper>
        </section>
    );
};
